import type { GeneratedContentPage } from '#layers/spaces/utils/content-pages';
import { computed } from 'vue';
import { usePermissionsStore } from '#layers/access/public';
import { useWorkspaceEntityStore } from '#layers/runtime/public';
import { applyContentPageDisplayOverride, getContentPageOverride, getGeneratedContentPages } from '#layers/spaces/utils/content-pages';

export function useContentPages() {
	const store = useWorkspaceEntityStore();
	const { hasAnyAccess } = usePermissionsStore();

	const generatedContentPages = computed(() => getGeneratedContentPages(store));
	const visibleContentPages = computed(() => generatedContentPages.value
		.filter((page) => !page.isHidden && (!page.collectionId || hasAnyAccess(page.collectionId)))
		.map((page) => resolveContentPageDisplay(page))
		.toSorted((a, b) => a.sort - b.sort || a.title.localeCompare(b.title)),
	);

	return {
		generatedContentPages,
		resolveContentPageDisplay,
		visibleContentPages,
	};

	function resolveContentPageDisplay(page: GeneratedContentPage): GeneratedContentPage {
		return applyContentPageDisplayOverride(page, getContentPageOverride(store, page));
	}
}
